import React, { useState } from "react";
import { LoaderModal, LoaderSign } from "./Loader.styled";
import LoaderImg from "./img/loaderImg.png";

const LoadingMsgs = [
  "Please wait while the minions do their work",
  "We're working very Hard .... Really",
  "...and enjoy the elevator music...",
  "The server is powered by a lemon and two electrodes",
  "Why don't you order a sandwich?",
  "Are we there yet?",
  "Just count to 10",
  "Counting backwards from Infinity",
  "We're making you a cookie",
  "Don't break your screen yet!",
  "I swear it's almost done",
  "Spinning the hamster…",
  "Convincing AI not to turn evil..",
  "Computing the secret to life, the universe, and everything",
  "We are not liable for any broken screens as a result of waiting",
  "Well, this is embarrassing",
  "Please hold on as we reheat our coffee",
  "Let's hope it's worth the wait",
  "Loading funny message...",
  "Help, I'm trapped in a loader!",
  "Never let a computer know you're in a hurry",
  "Patience! This is difficult, you know...",
  "Still faster than Windows update",
  "One mississippi, two mississippi...",
  "Computing chance of success",
];

export default function TMLoader({ title }) {
  const [currMsg] = useState(LoadingMsgs[Math.floor(Math.random() * 24)]);

  return (
    <LoaderModal
      title=""
      open={true}
      maskClosable={false}
      footer={null}
      closeIcon={null}
      centered
    >
      <div className="logoImg">
        <img src={LoaderImg} alt="loaderImg" />
      </div>

      <div className="loadingContent">
        <LoaderSign />

        <p>{title ? title : currMsg}</p>
      </div>
    </LoaderModal>
  );
}
